import './UploadFile.scss';

import { message } from 'antd';

import FileData from '@/model/General/FileData';

import DragAndDrop from './DragAndDrop';

interface UploadFileComponentProps {
  fileList: FileData[];
  setFileList: Function;
}

const UploadFileComponent = (props: UploadFileComponentProps) => {
  const { fileList, setFileList } = props;
  const handleFilesAdded = (files: File[]) => {
    const newFiles: FileData[] = [];

    files.forEach(file => {
      if (fileList.some((f: FileData) => f.title === file.name)) {
        message.error(`El archivo ${file.name} ya fue subido`);
      } else {
        const newTicketFile = FileData.fromFile(file);

        newFiles.push(newTicketFile);
      }
    });
    setFileList((prevFiles: File[]) => [...prevFiles, ...newFiles]);
  };

  return (
    <div className="UploadFileComponent">
      <DragAndDrop onFilesAdded={handleFilesAdded} />
    </div>
  );
};

export default UploadFileComponent;
